import { useEffect, useState } from 'react';
import { Typography } from '../../typography';
import { Button } from '../../button';
import { ModalBase, ModalWrapper, ModalFooterButtons } from '../ModalComponents';
import { useDeleteGateInMutation, useDeleteGateOutMutation } from '../../../hooks';
import { enqueueSnackbar } from '../../snackbar';
import { MESSAGES } from '../../../const';
import { i18n } from '../../../i18n';

interface GateDeleteModalType {
  data: {
    id: string;
    number: string;
  }[];
  isGateIn: boolean;
  submitClick: () => void;
  open: () => void;
}

export const gateDeleteModal: GateDeleteModalType = {
  data: [],
  isGateIn: true,
  submitClick: () => null,
  open: () => null,
};

export const GateDeleteModal = () => {
  const gateInDeleteMutation = useDeleteGateInMutation();
  const gateOutDeleteMutation = useDeleteGateOutMutation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    gateDeleteModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    gateDeleteModal.data = [];
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    const data = gateDeleteModal.data.map((item) => ({
      id: item.id,
    }));
    const onSuccess = () => {
      setOpen(false);
      gateDeleteModal.submitClick();
    };

    if (gateDeleteModal.isGateIn) {
      gateInDeleteMutation.mutate(data, {
        onSuccess,
        onError: () => {
          enqueueSnackbar(MESSAGES.GATE_IN.ERROR.NOT_DELETED, 'error');
        },
      });
      return;
    }

    gateOutDeleteMutation.mutate(data, {
      onSuccess,
      onError: () => {
        enqueueSnackbar(MESSAGES.GATE_OUT.ERROR.NOT_DELETED, 'error');
      },
    });
  };

  return (
    <ModalBase id={'gate-delete-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.gateDeleteTitle')}
        </Typography>
        {gateDeleteModal.data.map((item, i) => (
          <Typography key={i} variant={'textM'}>
            {item.number}
          </Typography>
        ))}
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
